"use client";

import { Icon } from "@iconify/react";
import { useEffect } from "react";

export default function Error({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    // Log the error to an error reporting service
  }, [error]);

  return (
    <div className="min-h-[60vh] flex flex-col items-center justify-center px-4 text-center">
      <div className="flex items-center justify-center mb-4">
        <Icon className="text-red-500 w-10 h-10" icon="lucide:alert-circle" />
      </div>
      <h2 className="text-xl md:text-2xl font-semibold text-gray-800">
        Oops, something went wrong.
      </h2>
      <p className="text-gray-500 mt-2 max-w-md">
        An unexpected error occurred. Please try again. If the problem persists,
        contact support.
      </p>
      <button
        className="mt-6 px-6 py-2 bg-primary text-white rounded-lg hover:bg-primary/90 transition"
        onClick={() => reset()}
      >
        Try Again
      </button>
    </div>
  );
}
